import { render } from "./MyPackageComponent.vue?vue&type=template&id=db214c3e"
import script from "./MyPackageComponent.vue?vue&type=script&lang=js"
export * from "./MyPackageComponent.vue?vue&type=script&lang=js"

import "./MyPackageComponent.vue?vue&type=style&index=0&id=db214c3e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__